/**
 *  @class
 *  @function DeferredMedia
 */
if (!customElements.get('deferred-media')) {
	function pauseAllMedia() {
	  document.querySelectorAll('.js-youtube').forEach((video) => video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*'));
	  document.querySelectorAll('.js-vimeo').forEach((video) => video.contentWindow.postMessage('{"method":"pause"}', '*'));
	  document.querySelectorAll('video').forEach((video) => video.pause());
	  document.querySelectorAll('product-model').forEach((model) => {
	    if (model.modelViewerUI) model.modelViewerUI.pause();
	  });
	}
	class DeferredMedia extends HTMLElement {
	  constructor() {
	    super();
	    const poster = this.querySelector('[id^="Deferred-Poster-"]');
	    if (!poster) return;
	    poster.addEventListener('click', this.loadContent.bind(this));
	  }

	  loadContent(focus = true) {
	    window.pauseAllMedia();
	    if (!this.getAttribute('loaded')) {
	      const content = document.createElement('div');
	      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
	      this.setAttribute('loaded', true);
	      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
	      if (focus) deferredElement.focus();
	      // force autoplay for safari
	      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) deferredElement.play();
	    }
	  }
	}
	customElements.define('deferred-media', DeferredMedia);
}